<h2 class="mat-dialog-title" mat-dialog-title class="text-secondary">Delete {{dialogDataInstance.title}}</h2>
<mat-dialog-content>
    <p class="text-center m-0 h3">Are you sure you want to delete {{dialogDataInstance.title}}?</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close (click)="dialogRef.close(false)">Cancel</button>
    <button mat-raised-button color="primary" [mat-dialog-close]="true" (click)="dialogRef.close(true)" cdkFocusInitial>Yes</button>
</mat-dialog-actions>